import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setTradeIn } from '../actions'
import Historical from './Historical'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(Historical)
